import React, { useState } from 'react';
import { withRouter } from 'react-router-dom';
import { MEASURES_RAW } from '../../../../containers/rawmaterials/constansts';
import { parseNumToFixed } from '../../../../utils/common';

const Item = ({ item, isMobile }) => {
    const [inputQuantity, setInputQuantity] = useState(item.quantity || 0);

    if (isMobile) {
        return (
            <tr
                key={item.id}
                className="kt-datatable__row"
                data-type={item.type}
                data-id={item.id}
            >
                <td colSpan="100%" className="kt-datatable__cell">
                    <div style={{ padding: '0.5rem' }}>
                        <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '0.5rem',
                            marginBottom: '0.5rem',
                        }}>
                            <div style={{
                                fontWeight: 600,
                                fontSize: '0.9rem',
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                flex: 1,
                                minWidth: 0
                            }}>
                                {`${MEASURES_RAW[item.measure] || '(Нет данных)'}`}
                            </div>

                            <input
                                type="number"
                                step="0.01"
                                className="form-control kt-form-input"
                                value={parseNumToFixed(inputQuantity, 3) || 0}
                                onChange={(e) => setInputQuantity(parseNumToFixed(e.target.value, 3))}
                                onFocus={(e) => e.target.select()}
                                style={{
                                    width: '50px',
                                    flexShrink: 0
                                }}
                            />
                        </div>
                    </div>
                </td>
            </tr>
        );
    }

    return (
        <tr
            key={item.id}
            className="kt-datatable__row"
            data-type={'data'}
            data-id={item.id}
        >
            <td width="200px" className="kt-datatable__cell">
                <span className="kt-font-bold">{item.name}</span>
            </td>
            <td width="auto" className="kt-datatable__cell">
                <span>{`${MEASURES_RAW[item.measure] || '(Нет данных)'}`}</span>
            </td>
            <td width="200px" className="kt-datatable__cell">
                <input
                    type="number"
                    step="0.001"
                    className="form-control kt-form-input"
                    value={parseNumToFixed(inputQuantity, 3) || 0}
                    onChange={(e) => setInputQuantity(parseNumToFixed(e.target.value, 3))}
                    onFocus={(e) => e.target.select()}
                    style={{width: '150px', margin: '0 auto'}}
                />
            </td>
        </tr>
    );
};

export const ItemRow = withRouter(Item);